import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ConfigProvider, theme as antdTheme } from "antd";

import "./main.component.styles.scss";
import { Header, Content, Footer } from "./layout";
import ScrollToTop from "./layout/scroll-to-top";
import { BottomTabBar } from "./navigations";
import StructuredData from "./seo/structured-data";
import StickyBookCta from "./navigations/sticky-book-cta";
import { CookieConsent } from "./generic";

// Kept in step with styles/abstracts/_variables.scss — antd components must
// not drift back to the old palette when the SCSS tokens move.
const lavienTheme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: "#a8461c",
    colorLink: "#a8461c",
    colorLinkHover: "#964016",
    colorText: "#221c17",
    colorTextSecondary: "#6f675f",
    colorBgBase: "#fbf7f1",
    colorBgContainer: "#ffffff",
    colorBorder: "rgba(64, 42, 24, 0.16)",
    colorBorderSecondary: "rgba(64, 42, 24, 0.10)",
    borderRadius: 999,
    borderRadiusLG: 20,
    fontFamily: '"Hanken Grotesk", -apple-system, "Helvetica Neue", Arial, sans-serif',
    fontSize: 16,
    controlHeight: 44,
    controlHeightLG: 52,
  },
  components: {
    Button: {
      primaryShadow: "none",
      defaultShadow: "none",
      fontWeight: 500,
    },
    Menu: {
      itemBg: "transparent",
      horizontalItemSelectedColor: "#a8461c",
      horizontalItemHoverColor: "#964016",
      itemColor: "#221c17",
      activeBarBorderWidth: 0,
      fontSize: 15,
    },
    Tabs: {
      inkBarColor: "#a8461c",
      itemActiveColor: "#221c17",
      itemSelectedColor: "#221c17",
      itemHoverColor: "#a8461c",
      titleFontSize: 15,
    },
    Drawer: {
      colorBgElevated: "#fbf7f1",
    },
  },
};

const Main: React.FC = () => {
  return (
    <HelmetProvider>
      <ConfigProvider theme={lavienTheme}>
        <StructuredData />
        <BrowserRouter>
          <ScrollToTop />
          {/* The copper ink-drop cursor is gone: a decorative custom cursor
              fights the pointer the OS already draws, and it painted a stray
              ring at 0,0 before the first mouse move. */}
          <div className="lvs-app">
            <Header />
            <main className="lvs-app__main">
              <Content />
            </main>
            <Footer />
            <StickyBookCta />
            <BottomTabBar />
            <CookieConsent />
          </div>
        </BrowserRouter>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default Main;
